import React from 'react';
import { Container, Row, Column } from '../../../components/grid/Grid';

import styles from './loader.module.scss';

const loaderLength = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const Loader = () => (
  <Container className={styles.container}>
    {loaderLength.map((item) => (
      <Row key={`loader-${item}`}>
        <Column small={12} medium={3}>
          <div className={styles.section} />
        </Column>
        <Column small={12} medium={7}>
          <div className={styles.section} />
        </Column>
        <Column small={12} medium={2}>
          <div className={styles.section} />
        </Column>
      </Row>
    ))}
  </Container>
);
